import _defineProperty from "/Users/preetpalsingh/CodeBase/six-respondent-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "/Users/preetpalsingh/CodeBase/six-respondent-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import * as React from 'react';
import styled from "../../styled";
import { Flex, Text } from ".."; //A Flex Box whose children are the actions passed into the PageHeader component as an array.

var ActionsContainer = styled(Flex)(function (_ref) {
  var theme = _ref.theme;
  return "\n  justify-content: flex-start;\n  max-width: 100%;\n  align-items: center;\n  flex-wrap: wrap;\n\n  & > * {\n    margin: ".concat(theme.space.xs, ";\n  }\n\n  & > :first-child {\n    margin-left: 0;\n  }\n\n  & > :last-child {\n    margin-right: 0;\n  }\n");
});
export var PageHeader = function PageHeader(_ref2) {
  var title = _ref2.title,
      actions = _ref2.actions,
      props = _objectWithoutProperties(_ref2, ["title", "actions"]);

  return React.createElement(Flex, Object.assign({}, props, {
    lss: _objectSpread({
      justifyContent: 'space-between',
      alignItems: 'center',
      flexWrap: 'wrap'
    }, props.lss)
  }), React.createElement(Text, {
    as: "h1",
    lss: _objectSpread({
      m: 'none',
      textScale: 'heading5',
      fontWeight: 'regular',
      mobile: {
        flex: '1 0 100%'
      },
      desktop: {
        flex: '1 0 auto'
      }
    }, props.titleLss)
  }, title), React.createElement(ActionsContainer, null, actions));
};